<template>
  <div class="text-sm flex flex-col gap-1">
    <vs-row
      v-if="parentType === VESSEL_TYPE()"
      vs-w="12"
    >
      <vs-col
        vs-w="5"
        class="font-semibold"
      >
        <span> Barge Name </span>
      </vs-col>
      <vs-col
        vs-w="7"
        class="flex justify-end text-right text-primary"
      >
        <span>
          {{ data.barge_name }}
        </span>
      </vs-col>
    </vs-row>
    <vs-row
      v-if="parentType === VESSEL_TYPE()"
      vs-w="12"
    >
      <vs-col
        vs-w="4"
        class="font-semibold"
      >
        <span> Status </span>
      </vs-col>
      <vs-col
        vs-w="8"
        class="flex justify-end gap-1 text-right font-semibold"
      >
        <span
          class="capitalize"
          :class="{
            'text-green': data.shipment_status.toLowerCase() === shipmentStatus.ON_TIME,
            'text-red': data.shipment_status.toLowerCase() === shipmentStatus.LATE,
          }"
        >
          [{{ data.shipment_status ? data.shipment_status.toLowerCase() : 'N/A' }}]
        </span>
        <span class="text-secondary capitalize">{{ data.blu_status ? data.blu_status.toLowerCase() : 'N/A' }}</span>
      </vs-col>
    </vs-row>
    <div class="timeline-wrapper">
      <div class="flex flex-row items-center justify-between">
        <span
          class="mx-2 absolute"
          :style="{
            left: leftPercentage
          }"
        >
          <svg
            width="24"
            height="22"
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.29478 0.598502L22.7316 9.26632C24.29 9.96131 24.29 12.0386 22.7316 12.7335L3.29478 21.4014C1.53374 22.1867 -0.292912 20.4428 0.579382 18.809L4.29025 11.8586C4.57886 11.3181 4.57886 10.6818 4.29025 10.1412L0.579382 3.19082C-0.292908 1.55703 1.53374 -0.186829 3.29478 0.598502Z"
              :fill="data.color"
            />
          </svg>
        </span>
        <div class="px-2">
          <vs-icon
            icon="circle"
            color="#FF0000"
            size="12px"
            class="mt-1"
          />
        </div>
        <div class="px-2">
          <div class="arrow-up" />
        </div>
        <div class="px-2">
          <div class="arrow-up" />
        </div>
        <div class="px-2">
          <vs-icon
            icon="circle"
            color="#FF0000"
            size="12px"
            class="mt-1"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-between">
      <span>Start</span>
      <span>POL</span>
      <span>POD</span>
      <span>End</span>
    </div>
    <vs-row
      vs-w="12"
      vs-justify="space-between"
      class="mt-2"
    >
      <vs-col
        vs-w="6"
        class="flex flex-col gap-1"
      >
        <vs-row class="position-title-details">
          <span>POL</span>
        </vs-row>
        <vs-row class="position-details">
          <img :src="require('@/assets/shipo-icon-calendar-eta-black.svg')">
          <span>{{ validateAndFormatDate(data.plan_pol) }}</span>
        </vs-row>
        <vs-row class="position-details">
          <img :src="require('@/assets/shipo-icon-calendar-black.svg')">
          <span>{{ validateAndFormatDate(data.actual_pol) }}</span>
        </vs-row>
        <vs-row class="position-details">
          <img :src="require('@/assets/shipo-icon-stopwatch-pause.svg')">
          <span
            v-if="!isBefore(data.plan_pol, data.actual_pol)"
          >
            Delay {{ handleValidateAndFormatNumber(data.delay_pol, 2) }} days
          </span>
          <span v-else>No Delay</span>
        </vs-row>
      </vs-col>
      <vs-col
        vs-w="6"
        class="flex flex-col gap-1"
      >
        <vs-row class="position-title-details">
          <span>POD</span>
        </vs-row>
        <vs-row class="position-details">
          <img :src="require('@/assets/shipo-icon-calendar-eta-black.svg')">
          <span>{{ validateAndFormatDate(data.plan_pod) }}</span>
        </vs-row>
        <vs-row class="position-details">
          <img :src="require('@/assets/shipo-icon-calendar-black.svg')">
          <span>{{ validateAndFormatDate(data.actual_pod) }}</span>
        </vs-row>
        <vs-row class="position-details">
          <img :src="require('@/assets/shipo-icon-stopwatch-pause.svg')">
          <span
            v-if="!isBefore(data.plan_pod, data.actual_pod)"
          >
            Delay {{ handleValidateAndFormatNumber(data.delay_pod, 2) }} days
          </span>
          <span v-else>No Delay</span>
        </vs-row>
      </vs-col>
    </vs-row>
    <div v-if="parentType === VESSEL_TYPE()">
      <span
        class="mt-2 w-full flex flex-row items-center justify-end font-semibold underline cursor-pointer"
        style="color: #56B9F2"
        @click="handleViewBargeDetail"
      >
        View Barge Detail
        <img :src="require('@/assets/shipo-icon-double-arrow-right.svg')">
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";

import {TUG_TYPE, VESSEL_TYPE} from "@/fixtures/Constants";

export default {
  name: 'BargePosition',
  props: {
    parentType: {
      type: String,
      default: TUG_TYPE
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      shipmentStatus: {
        ON_TIME: 'on time',
        LATE: 'late'
      }
    }
  },
  methods: {
    VESSEL_TYPE() {
      return VESSEL_TYPE
    },
    validateAndFormatDate(date, format = "DD MMM YYYY HH:mm") {
      if (!date || date === '-') {
        return 'N/A'
      }
      const parsedDate = this.moment(date)
      if (parsedDate.isValid()) {
        if (this.moment(date, format, true).isValid()) {
          return date
        }

        return moment.utc(parsedDate).local().format(format)
      }
      return 'N/A'
    },
    handleViewBargeDetail() {
      this.$emit('viewTugBargeDetail', this.data.id)
    },
    isBefore(plan, actual) {
      return moment(actual).isBefore(moment(plan))
    }
  },
  computed: {
    leftPercentage() {
      const step = 16;
      let base = 0;
      const position = this.data?.barge_position?.toLowerCase()
      switch (true) {
        case position === 'start':
          base = -0.125
          break
        case position === 'start - pol':
          base = 0.8
          break
        case position === 'pol':
          base = 1.8
          break
        case position === 'pol - pod':
          base = 2.7
          break
        case position === 'pod':
          base = 3.7
          break
        case position === 'pod - end':
          base = 4.6
          break
        case position === 'end':
          base = 5.5
          break
        default:
          base = 0
          break;
      }

      return `${step * base + 1}%`
    }
  }
}
</script>

<style lang="scss" scoped>
.text-green {
  color: #15AF59;
}

.text-red {
  color: #FF0000;
}

.timeline-wrapper {
  position: relative;
  text-align: center;
}

.timeline-wrapper::before {
  @apply mx-3;
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: black;
  z-index: 0;
}

.timeline-wrapper > .flex {
  position: relative;
  z-index: 1;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 12px solid #FF7E57;
}

.position-title-details {
  @apply mb-2;
  @apply font-semibold;
  @apply text-base;
}

.position-details {
  @apply flex flex-row items-center gap-2;
  @apply text-primary;

  img {
    width: 1.5em;
    height: auto;
  }
}
</style>